// extracted by mini-css-extract-plugin
module.exports = {"borderGrey":"#B5B4B5","zIndexModalBackdrop":"1040","container":"_1g22zWOenqYUNHmp","error":"_3rIhsHrNT_iAb7yW","info":"rGOsYiXdPwm8XXmP"};